import { toast } from "react-toastify";
import { call, put, takeEvery } from "redux-saga/effects";
import { onLoaderTrigger } from "redux/actions/CommonAction";
import { getCustomer } from "redux/actions/UserCustomer";
import store from "redux/store";
import { GET_CUSTOMER_FAILED, GET_CUSTOMER_REQUESTED, GET_CUSTOMER_SUCCESS, GET_MATRIXCUSTOMER_FAILED, GET_MATRIXCUSTOMER_REQUESTED, GET_MATRIXCUSTOMER_SUCCESS, GET_TICKETCUSTOMER_FAILED, GET_TICKETCUSTOMER_REQUESTED, GET_TICKETCUSTOMER_SUCCESS, UPDATE_CUSTOMER_FAILED, UPDATE_CUSTOMER_REQUESTED, UPDATE_CUSTOMER_SUCCESS } from "resources/actionTypes";
import { customerApi, matrixCustomerApi, ticketCustomerApi, updateCustomerApi } from "services/CustomerService";

function* fetchCustomer(action) {
  try {
    const payload = action.payload || {}
    const userCustomer = yield call(customerApi,payload);
    yield put({ type: GET_CUSTOMER_SUCCESS, userCustomer: userCustomer });
  } catch (e) {
    yield put({ type: GET_CUSTOMER_FAILED, message: e.message });
    toast.error(e.message || 'Get Customer Failed')
  }
}

export function* customerSaga() {
  yield takeEvery(GET_CUSTOMER_REQUESTED, fetchCustomer);
}

function* fetchMatrixCustomer(action) {
  try {
    const payload = action.payload || {}
    const userMatrixCustomer = yield call(matrixCustomerApi, payload);
    yield put({
      type: GET_MATRIXCUSTOMER_SUCCESS,
      userMatrixCustomer: userMatrixCustomer
    });
  } catch (e) {
    yield put({
      type: GET_MATRIXCUSTOMER_FAILED,
      message: e.message
    })
    toast.error(e.message || 'Get Matrix Customer Failed')
  }
}

export function* matrixCustomerSaga() {
  yield takeEvery(GET_MATRIXCUSTOMER_REQUESTED,
    fetchMatrixCustomer);
}

function* fetchTicketCustomer(action) {
  try {
    const payload = action.payload || {}
    const userTicketCustomer = yield call(ticketCustomerApi, payload);
    yield put({
      type: GET_TICKETCUSTOMER_SUCCESS,
      userTicketCustomer: userTicketCustomer
    });
  } catch (e) {
    yield put({
      type: GET_TICKETCUSTOMER_FAILED,
      message: e.message
    })
    toast.error(e.message || 'Get Ticket Customer Failed')
  }
}

export function* ticketCustomerSaga() {
  yield takeEvery(GET_TICKETCUSTOMER_REQUESTED,
    fetchTicketCustomer);
}

function* fetchUpdateCustomer(action) {
  const payload = action.payload || {}
  store.dispatch(onLoaderTrigger(true));
  const userUpdateCustomer = yield call(updateCustomerApi, payload.userUpdateCustomer);
  if(userUpdateCustomer.success){
    yield put({ type: UPDATE_CUSTOMER_SUCCESS, userUpdateCustomer: userUpdateCustomer });
    toast.success(userUpdateCustomer.message);
    store.dispatch(onLoaderTrigger(false));
    if(payload?.userUpdateCustomer?.id){
      store.dispatch(getCustomer({id: payload.userUpdateCustomer.customerId}));
    }else{
      store.dispatch(getCustomer({status:'', page:payload?.userUpdateCustomer?.data?.page, pageSize:payload?.userUpdateCustomer?.data?.rowsPerPage, dateFrom:'', dateTo:'', search:''}));
    }
  }else{
    store.dispatch(onLoaderTrigger(false));
    yield put({ type: UPDATE_CUSTOMER_FAILED, message: userUpdateCustomer.message });
      toast.error(userUpdateCustomer.message || 'Update Customer failed');
  }
}
export function* updateCustomerSaga() {
  yield takeEvery(UPDATE_CUSTOMER_REQUESTED, fetchUpdateCustomer);

}